import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5001/api";

export const listTemplatesRequest = async ({ uid }) => {
  // console.log("FRONTEND API - LIST TEMPLATES FOR UID:", uid);

  const response = await axios.get(`${API_BASE_URL}/templates`, {
    params: {
      uid,
    },
  });

  // console.log("FRONTEND API - TEMPLATES RETURNED:", response.data.templates);

  return response.data.templates;
};

export const getTemplateRequest = async ({ uid, templateId }) => {
  // console.log("FRONTEND API - GET TEMPLATE:", {
  //   uid,
  //   templateId,
  // });

  const response = await axios.get(`${API_BASE_URL}/templates/${templateId}`, {
    params: {
      uid,
    },
  });

  // console.log("FRONTEND API - TEMPLATE RETURNED:", response.data.template);

  return response.data.template;
};

export const createTemplateRequest = async ({ template }) => {
  // console.log("FRONTEND API - CREATE TEMPLATE BODY SENT:", template);

  const response = await axios.post(`${API_BASE_URL}/templates`, template);

  // console.log(
  //   "FRONTEND API - CREATED TEMPLATE RETURNED:",
  //   response.data.template,
  // );

  return response.data.template;
};

export const updateTemplateRequest = async ({ templateId, template }) => {
  // console.log("FRONTEND API - UPDATE TEMPLATE BODY SENT:", {
  //   templateId,
  //   template,
  // });

  const response = await axios.patch(
    `${API_BASE_URL}/templates/${templateId}`,
    template,
  );

  // console.log(
  //   "FRONTEND API - UPDATED TEMPLATE RETURNED:",
  //   response.data.template,
  // );

  return response.data.template;
};

export const deleteTemplateRequest = async ({ uid, templateId }) => {
  // console.log("FRONTEND API - DELETE TEMPLATE:", {
  //   uid,
  //   templateId,
  // });

  const response = await axios.delete(
    `${API_BASE_URL}/templates/${templateId}`,
    {
      params: {
        uid,
      },
    },
  );

  // console.log("FRONTEND API - DELETED TEMPLATE:", response.data);

  return response.data;
};
